import webBiLogger from '@wix/web-bi-logger';

function createBiLogger(visitorId: string, msid: string) {
  return webBiLogger
    .factory()
    .withUoUContext({ visitorId, msid })
    .logger();
}
export default createBiLogger;
